import React from 'react'
import { motion } from 'framer-motion';
import APP2SCREEN from '../../../../app/assets/images/projectImage/aiDoctorImage/app2Screen.webp';
import WEB2 from '../../../../app/assets/images/projectImage/aiDoctorImage/web2.webp';

// Animation variants
const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
};

const fadeInLeft = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.6 } }
};

const fadeInRight = {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.6 } }
};

const scaleIn = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.6 } }
};

const staggerContainer = {
    hidden: { opacity: 1 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.2
        }
    }
};

const hoverElevate = {
    y: -5,
    transition: { duration: 0.3 }
};

const AIDoctorProjectContent = () => {
    return (
        <div className=''>
            <motion.div
                className='flex flex-col items-center justify-center'
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={staggerContainer}
            >
                <motion.img
                    src={WEB2}
                    alt='AIDoctorProjectContent'
                    className='w-full md:w-[70%] xl:w-[80%] 2xl:w-[70%]  h-full object-cover z-10'
                    variants={scaleIn}
                    whileHover={hoverElevate}
                />
                <motion.div
                    className='flex flex-col items-center justify-center gap-4 pt-40 md:pt-60 xl:pt-40 relative top-[-150px] sm:top-[-200px] md:top-[-250px] w-full '
                    style={{
                        background: 'linear-gradient(135deg, #4B4AD5 0%, #A461D8 100%)',
                    }}
                    variants={staggerContainer}
                >
                    <motion.div
                        className='text-3xl sm:text-4xl md:text-5xl font-bold leading-snug pl-4 sm:pl-6 md:pl-10 uppercase text-white text-center sm:text-left'
                        variants={fadeInUp}
                    >
                        Key Objectives
                    </motion.div>
                    <motion.div
                        className='text-white text-base sm:text-lg md:text-xl font-medium !pt-0 p-4 sm:p-6 md:p-8 pl-4 sm:pl-6 md:pl-10 pr-4 sm:pr-12 md:pr-24 leading-7 sm:leading-8 text-center w-full md:w-5/6 xl:w-2/3'
                        variants={fadeInUp}
                    >
                        The key objectives focus on designing a trust-centered UI for health-related conversations while
                        creating a natural, human-like AI chat experience. The system provides structured access to vaccination
                        and medical data and maintains a unified flow across both mobile and web platforms. Throughout the
                        experience, readability and accessibility are prioritized to ensure usability for a diverse audience.
                    </motion.div>
                </motion.div>
            </motion.div>

            <motion.div
                className='flex flex-col md:flex-row items-center justify-center gap-6 md:gap-0'
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={staggerContainer}
            >
                <motion.img
                    src={APP2SCREEN}
                    alt='AIDoctorProjectOverview'
                    className='w-full md:w-[50%] h-full object-cover order-1'
                    variants={fadeInLeft}
                    whileHover={hoverElevate}
                />

                <motion.div
                    className='flex flex-col gap-4 w-full md:w-auto order-2'
                    variants={fadeInRight}
                >
                    <motion.div
                        className='text-3xl sm:text-4xl md:text-5xl font-bold leading-snug pl-4 sm:pl-6 md:pl-10 uppercase text-white'
                        variants={fadeInUp}
                    >
                        the solution
                    </motion.div>
                    <motion.div
                        className='text-white text-base sm:text-lg md:text-xl font-medium p-4 sm:p-6 md:p-8 pl-4 sm:pl-6 md:pl-10 pr-4 sm:pr-12 md:pr-24 leading-7 sm:leading-8'
                        style={{
                            background: 'linear-gradient(135deg, #4B4AD5 0%, #A461D8 100%)',
                        }}
                        variants={fadeInUp}
                    >
                        The solution was to build a complete AI-powered medical assistant ecosystem
                        that delivers a unified experience across both mobile and desktop platforms.
                        It features a conversational AI chat that lets users ask health-related questions
                        anytime, supported by a personalized dashboard offering quick shortcuts,
                        recent conversations, and recommended medical topics. The system also
                        provides vaccination lookup & access to health records, helping users easily
                        track & understand their medical information. All of this is wrapped in a clean,
                        modern UI with soft gradients, large touch-friendly cards, and a minimal
                        layout designed to maintain clarity and calmness—an essential quality
                        in healthcare interfaces.
                    </motion.div>
                </motion.div>
            </motion.div>
        </div>
    )
}

export default AIDoctorProjectContent